module.exports = __webpack_public_path__ + "static/media/notebook.c63fe684.png";